import axios from "axios";

export const fetchWeather = async ({ latitude, longitude, apiKey }) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_WEATHER,
      {
        params: {
          lat: latitude,
          lon: longitude,
          appid: apiKey,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
